import { render, staticRenderFns } from "./bsp-dicts-city.vue?vue&type=template&id=e413675a&scoped=true&"
import script from "./bsp-dicts-city.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-city.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-city.vue?vue&type=style&index=0&id=e413675a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e413675a",
  null
  
)

export default component.exports